const seerBase = { v: 12 };
const eventListingsEventConfigs = {
  contactScreenSubmit: {
    event: 'event_listings_contact_screen_submit',
    name: 'Event Listings Contact Screen Submit',
    event_listing_purchase_id: '',
    ...seerBase,
  },
  createScreenSubmit: {
    event: 'event_listings_create_screen_submit',
    name: 'Event Listings Create Screen Submit',
    ...seerBase,
  },
  paymentScreenSubmit: {
    event: 'event_listings_payment_submit',
    name: 'Event Listings Payment Submit',
    event_listing_cost: null,
    ...seerBase,
  },
  listingPreview: {
    event: 'event_listings_preview',
    name: 'Event Listings Preview',
    ...seerBase,
  },
};

export default eventListingsEventConfigs;
